import anime from 'animejs/lib/anime.es.js';
class ModalClass {
	constructor ( option ) {
    this.body= document.body,
		this.modalArea= option.elem,
    this.modalWrap= document.getElementById('modal-wrap'),
		this.value= option.value,
		this.exdays= option.exdays
    this.offModalCallback();
	}

  showModalDetail ( option ) {
    var that= this
      , target= option.target
      , selector= option.selector
      , url= option.url
      , callback= option.callback
      , obj= {
          selector: selector,
          callback: ( self )=> {
            var listVal= self.querySelectorAll('[data-board-detail]'),
              key= self.dataset.index,
              arr= {};

            _jh.each(listVal, function(idx, val) {
              arr[this.dataset.boardDetail]= this.innerHTML;
            });

            var paramObj= {
              key: key,
              data: arr                 
            }

            if( option.params ) paramObj.params= option.params;
            that.OnModal();
            if( url ) {
              axios.post(option.url, paramObj)
              .then(function (res) {
                that.modalWrap.innerHTML= res.data;
                callback && callback(self, that);
              })
              .catch(function (error) {
                console.log(error);
              });
            } else {
              callback && callback(self, this);
            }
          }
        };

    target.addEventListener('click', (e)=> {
      const selectElem= this.dir(e.target, 'parentNode', obj.selector);
      if( selectElem.length > 0 ) {
        if( option.exceptEvtClassName && selectElem[0].classList.contains(option.exceptEvtClassName) ) return;
        obj.callback(selectElem[0]);
      }
    });
  }

  showModalFront ( elem ) {
    _jh.on('click', elem, (e)=> {
      this.modalWrap.innerHTML= jhc.modalCont[e.currentTarget.dataset.modalCont];
      this.OnModal();
    });
  }

  OnModal () {
    // this.modalArea.classList.add('on');
    let check= null;
    this.modalArea.classList.add('on');
    this.body.classList.add('hidden');

    anime({
      targets: this.modalArea,
      duration: 300,
      opacity: 1,
      easing: 'linear',
      // visibility: 'visible',
      complete: anime => {
        // this.body.classList.add('hidden');
      },
      update: anim=> {
        if( !check && anim.progress >= 50 ) {
          // this.body.classList.add('hidden');
          console.log('progress : '+Math.round(anim.progress)+'%');
          check= true;
        }
      }
    });
    
  }

  OffModal () {
    if( this.modalArea.classList.contains('on') ) {
      this.body.classList.remove('hidden');
      anime({
        targets: this.modalArea,
        duration: 300,
        opacity: 0,
        easing: 'linear',
        complete: anime => {
          this.modalArea.classList.remove('on');
          this.modalWrap.innerHTML= ''
        }
      })
      // this.modalArea.classList.remove('on');
    }
  }

  offModalCallback () {
    // this.modalArea.addEventListener('transitionend',(e)=> console.dir(e.target))
  }

  containClassId ( elem, elemStr ) {
    const name= elemStr.slice(1);
    return elemStr.slice(0,1) === "#" ? (elem.id === name) : elem.classList.contains(name);
  }

  dir ( elem, dir, targetElem ) {
    var matched = [];
    if( this.containClassId(elem, targetElem) ) {
      matched.push( elem );
      return matched;
    }
    while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
      if ( elem.nodeType === 1 ) {
        if( this.containClassId(elem, targetElem) ) {
          matched.push( elem );
          break;
        }
      }
    }
    return matched;
  }

  ClipModal () {
    var that= this;
    this.modalArea.addEventListener('transitionend', function(e) {
      if( e.propertyName !== 'transform' ) return;
      if( this.classList.contains('on') ) {
        document.addEventListener('mousedown', clipEvent);
      } else {
        document.removeEventListener('mousedown', clipEvent);
      }
    });

    const clipEvent= (e)=> {
      if( this.dir(e.target, 'parentNode', '#modal-area').length > 0 || 
        e.target.id === 'modal-area' ) 
        return;
      this.OffModal();
      return;
    }
  }
	
}

export const Modal= ModalClass;